import { ResourceProvider } from "../../providers/resource.provider"
import { DiscountCampaign } from "./Campaign";
import { DiscountCampaignSerializer } from "./serialize";

export class DiscountCampaignProvider extends ResourceProvider<DiscountCampaign> {
    constructor() {
        super("rest_discount_campaign", new DiscountCampaignSerializer());
    }
}

export const discountCampaignService = new DiscountCampaignProvider()
